import React, { ReactElement } from 'react'
import Header from './Header'
import Footer from './Footer'
import MenuMobile from './MenuMobile'
import PopupGoogleMap from "../common/PopupGoogleMap";
interface Props {
    children: ReactElement
}
const Layout: React.FC<Props> = ({ children }) => {
    return (
        <div className="pageWrapper">
            <MenuMobile />
            <Header />
            <div className="main">{children}</div>
            <Footer />
            <PopupGoogleMap/>
        </div>
    )
}

export default Layout
